import { Toaster } from "react-hot-toast";
import "./App.css";
import RouterMain from "./RouterMain";

function App() {
  return (
    <div>
      <Toaster
        position="top-right"
        reverseOrder={false}
      />
      <RouterMain />
    </div>
  );
}

export default App;
